import {
  Box,
  Collapse,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import { Edit, Trash2, ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';
import { Subtype } from '../../types/ServiceAccordion.type';
import ServiceSubSubTypeList from './ServiceSubSubTypeList';
import TreeBranch, { treeItemSx } from '../common/TreeBranch';

interface ServiceSubtypeCardProps {
  subtype: Subtype;
  onEdit: (subtype: Subtype) => void;
  onDelete: (subtype: Subtype) => void;
  fetchServiceTypes: () => void;
}

const ServiceSubtypeCard: React.FC<ServiceSubtypeCardProps> = ({
  subtype,
  onEdit,
  onDelete,
  fetchServiceTypes,
}) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <>
      <ListItem
        disablePadding
        secondaryAction={
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 8 }}>
            <IconButton
              edge="end"
              aria-label="edit"
              onClick={() => onEdit(subtype)}
              sx={{ mr: 0 }}
            >
              <Edit size={16} />
            </IconButton>
            <IconButton
              edge="end"
              aria-label="delete"
              onClick={() => onDelete(subtype)}
            >
              <Trash2 size={16} />
            </IconButton>
          </Box>
        }
        sx={[
          {
            mb: 1,
            backgroundColor: 'background.paper',
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'divider',
            '&:hover': {
              backgroundColor: 'action.hover',
            },
          },
          treeItemSx,
        ]}
      >
        <ListItemButton onClick={handleToggle} dense>
          <ListItemText
            primary={
              <Typography variant="body1" component="div" fontWeight="medium">
                {subtype.name}
              </Typography>
            }
          />
          {open ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </ListItemButton>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <TreeBranch>
          <ServiceSubSubTypeList
            subtype={subtype}
            subsubtypes={subtype.subsubtypes}
            fetchServiceTypes={fetchServiceTypes}
          />
        </TreeBranch>
      </Collapse>
    </>
  );
};

export default ServiceSubtypeCard;
